import { Component, OnInit, ViewChild } from '@angular/core';
import { AuditLogsService } from '@data/auditReports/audit-logs.service';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { NotificationService } from '@shared/services/notification.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import * as saveAs from 'file-saver';

interface PublishHistory{
  psrPublishHistoryId?: number|null;
  psrGroupId?: number|null;
  publishedPDFName:string;
  weekendingDt:Date|string;
  publishedDate:Date|string;
  publishedBy:string;
  publishStatus:boolean;
  accessRevokedFlag:boolean|null;
}

@Component({
  selector: 'app-psr-publish-history',
  templateUrl: './psr-publish-history.component.html',
  styleUrls: ['./psr-publish-history.component.less']
})
export class PsrPublishHistoryComponent implements OnInit {

  loadingData=true;

  showLoadPanel=false;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#publishHistoryGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };

  publishHistoryList:PublishHistory[];

  displayColumns = [
    { caption: 'Report Name', dataField: 'publishedPDFName', dataType: 'string', format: "", cellTemplate:null},
    { caption: 'Weekending Date', dataField: 'weekendingDt', dataType: 'date', format: "MM/dd/yy", cellTemplate:null},
    { caption: 'Publish Date', dataField: 'publishedDate', dataType: 'date', format: "MM/dd/yy, HH:mm aa", cellTemplate:null},
    { caption: 'Published By', dataField: 'publisherName', dataType: 'string', format: "", cellTemplate:null},
    { caption: 'Published Status', dataField: 'publishStatus', dataType: 'string', format: "", cellTemplate:'publishStatusCell'},
    { caption: 'Access Revoked', dataField: 'accessRevokedFlag', dataType: 'string', format: "", cellTemplate:'accessRevokedCell'},
  ];
  showPhAdmin: boolean = true;
  disPhAdmin: boolean = true;
  @ViewChild('publishHistoryGrid') grid: DxDataGridComponent;

  constructor(private _aud: AuditLogsService, private commonServices: CommonDataService, private _notify:NotificationService){
    const userData = this.commonServices.userData.value;
		const getSectionName = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === "Admin");
    if(getSectionName[0].permissionName == "READ/WRITE"){
			this.showPhAdmin = true;
		}else if(getSectionName[0].permissionName == "READ ONLY"){
			this.showPhAdmin = true;
			this.disPhAdmin=true;
		}else{
			this.showPhAdmin = false;
		}
    this.loadingData=true;
    this.fetchPublishHistoryData();
  }

  ngOnInit(): void {
  }

  fetchPublishHistoryData(){
    if(!this.loadingData)
      this.showLoadPanel=true;
    this._aud.getPublishHistory().subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          if(r.serviceResult)
            this.publishHistoryList=r.serviceResult;
          else
            this.publishHistoryList=[];
          this.showLoadPanel=false;
          this.loadingData=false;
        }
      }
    )
  }

  onExporting(e:any) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('PSR Publish History');

    exportDataGrid({
      component: this.grid.instance,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function(options) {
        const { gridCell, excelCell } = options;
        
        if (gridCell?.rowType === 'data') {
          if (gridCell.column?.dataField === 'publishStatus') {
            excelCell.value = gridCell.value?'SUCCESS':'FAILED';
          }
          if (gridCell.column?.dataField === 'accessRevokedFlag') {
            excelCell.value = gridCell.value?'YES':'NO';
          }
        }
      }
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PSRPublishHistory.xlsx');
      });
    });
    e.cancel = true;
  }

  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('publish-history');
  }

}
